// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import "./api";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* AppProvider DEBE estar por fuera */}
      <AppProvider>
        <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3200,
              style: {
                background: '#151821',
                color: '#f3f4f6',
                border: '1px solid #303442',
              },
              success: { iconTheme: { primary: '#22c55e', secondary: '#111827' } },
              error: { iconTheme: { primary: '#ef4444', secondary: '#111827' } },
            }}
          />
        </AuthProvider>
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>
);
